import { Stack } from 'react-bootstrap';

export const ProveMobileComplete = () => (
  <Stack gap={3} className="align-items-center text-center mt-2">
    <div className="h3 text-secondary mb-0">
      Phone Number Verification Complete
    </div>
    <div className="fs-5">
      Return to your computer to continue your application.
    </div>
  </Stack>
);

export default ProveMobileComplete;
